(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    console.log('ProductRecommendations component initialized.');

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      console.log('Fetching data from URL:', this.dataset.url);

      fetch(this.dataset.url)
        .then(response => {
          console.log('Fetch response status:', response.status);
          return response.text();
        })
        .then(text => {
          console.log('Fetched HTML:', text);
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            console.log('Recommendations innerHTML before update:', recommendations.innerHTML);
            this.innerHTML = recommendations.innerHTML;

            // Log each image element
            const images = this.querySelectorAll('img');
            images.forEach((img, index) => {
              console.log(`Image ${index} src:`, img.src);
            });

            if (images.length === 0) {
              console.error('No images found in the recommendations.');
            }
          } else {
            console.error('No recommendations element found.');
          }

          if (html.querySelector('.grid__item img')) {
            this.classList.add('product-recommendations--loaded');
          } else {
            console.error('Images are missing in the recommendations.');
          }
        })
        .catch(e => {
          console.error('Fetch error:', e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
